// src/components/OnlineTest.js
import React from "react";
import "./OnlineTest.css";

const OnlineTest = () => {
  return (
    <div className="online-test-container">
      <h1>Online Test Platform</h1>
      <iframe
        src="https://chess-kqh.glitch.me/"
        width="100%"
        height="500px"
        frameBorder="0"
        title="Online Test Platform"
        allow="fullscreen"
      ></iframe>
    </div>
  );
};

export default OnlineTest;
